import { useState } from "react";
import { useNavigate } from "react-router-dom";
import LoginModal from "@/components/LoginModal.jsx";
import { GuestAuthModal } from "@/components/GuestAuthPrompt.jsx";
import { MAIN_ROUTE } from "@/utils/constants.js";

export default function CustomerAuthGate({ returnTo }) {
    const navigate = useNavigate();
    const [showLogin, setShowLogin] = useState(false);
    const [loginMode, setLoginMode] = useState("login");

    const handleDismiss = () => {
        navigate(MAIN_ROUTE, { replace: true });
    };

    const openLogin = () => {
        setLoginMode("login");
        setShowLogin(true);
    };

    const openRegister = () => {
        setLoginMode("register");
        setShowLogin(true);
    };

    if (showLogin) {
        return (
            <LoginModal
                initialMode={loginMode}
                returnTo={returnTo}
                onClose={() => setShowLogin(false)}
            />
        );
    }

    return (
        <GuestAuthModal
            onLogin={openLogin}
            onRegister={openRegister}
            onDismiss={handleDismiss}
        />
    );
}
